
import * as React from 'react'
import { Image, Text, View, TouchableOpacity, ScrollView } from 'react-native'
import images from '../../assets/images'
import { useTheme } from '@react-navigation/native'
import moment from 'moment'
import AnimatedProgressWheel from 'react-native-progress-wheel'
import Axios from 'axios'
import { RefreshControl } from 'react-native-web-refresh-control'

export default React.memo(function FinanceDate({ day_string, tripFilter }) {
    const { colors } = useTheme()
    const [data, setData] = React.useState()
    const [refreshing, setRefreshing] = React.useState(true)

    React.useEffect(() => {
        setRefreshing(true)
        Axios.get(`/api/ceo/revenue-by-day?day=${moment(day_string, 'DD/MM/YYYY').format('YYYY-MM-DD')}&type=${tripFilter <= 2 ? tripFilter : 0}`)
            .then(res => {
                console.log(res)
                if (res.status === 200)
                    setData(res.data)
                setRefreshing(false)
            }).catch(err => {
                setRefreshing(false)
                console.log(err)
            })
    }, [day_string, tripFilter])

    const getColorProgress = (value) => {
        try {
            if (value < 50) return colors.process_3
            else if (value < 75) return colors.process_1
            else return colors.process_2
        } catch (error) {
        }
    }

    const getColorText = (value) => {
        try {
            if (value < 50) return colors.text_red
            else if (value < 75) return colors.text_yellow
            else return colors.text_green
        } catch (error) {
        }
    }

    const onRefresh = () => {
        setRefreshing(true)
        Axios.get(`/api/ceo/revenue-by-day?day=${moment(day_string, 'DD/MM/YYYY').format('YYYY-MM-DD')}&type=${tripFilter}`)
            .then(res => {
                console.log(res)
                if (res.status === 200) {
                    setData(res.data)
                }
                setRefreshing(false)
            }).catch(err => {
                setRefreshing(false)
                console.log(err)
            })
    }

    return (
        <ScrollView style={{ flex: 1 }} refreshControl={<RefreshControl refreshing={refreshing} onRefresh={onRefresh} tintColor={colors.text} colors={[colors.text]} />}>
            {
                data ? <>
                    <View style={{ backgroundColor: 'white', marginHorizontal: 12, marginTop: 18, borderRadius: 10, paddingHorizontal: 15 }}>
                        <View style={{ marginTop: 8, flexDirection: 'row' }}>
                            <View style={{ flex: 1 }}>
                                <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 15, color: colors.text }}>TỔNG DOANH THU</Text>
                                <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 32, color: colors.text }}>{data?.percent_total?.total_revenue?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                            </View>
                            <View>
                                <Image source={images.icons.icon_money} style={{ width: 40, height: 40, resizeMode: 'contain' }} />
                            </View>
                        </View>
                        <View style={{ flexDirection: 'row', marginBottom: 16, marginTop: 12 }}>
                            <View style={{
                                height: 28, position: 'relative', flex: 1, backgroundColor: colors.process_background, borderRadius: 3,
                                justifyContent: 'center'
                            }}>
                                <View style={{
                                    position: 'absolute', top: 0, left: 0, width: `${data?.percent_total?.revenue_total_last > 100 ? 100 : data?.percent_total?.revenue_total_last}%`,
                                    height: '100%', backgroundColor: getColorProgress(data?.percent_total?.revenue_total_last), borderRadius: 3
                                }} />
                                <View style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', justifyContent: 'center' }}>
                                    <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', paddingHorizontal: 6 }}>{data?.percent_total?.revenue_total_last}% tuần trước</Text>
                                </View>
                            </View>
                            <View style={{ width: 16 }} />
                            <View style={{
                                height: 28, position: 'relative', flex: 1, backgroundColor: colors.process_background, borderRadius: 3,
                                justifyContent: 'center'
                            }}>
                                <View style={{
                                    position: 'absolute', top: 0, left: 0, width: `${data?.percent_total?.revenue_plan_total > 100 ? 100 : data?.percent_total?.revenue_plan_total}%`,
                                    height: '100%', backgroundColor: getColorProgress(data?.percent_total?.revenue_plan_total), borderRadius: 3
                                }} />
                                <View style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', justifyContent: 'center' }}>
                                    <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', paddingHorizontal: 6 }}>{data?.percent_total?.revenue_plan_total}% kế hoạch</Text>
                                </View>
                            </View>
                        </View>
                    </View>

                    <View style={{ backgroundColor: 'white', marginHorizontal: 12, marginTop: 18, borderRadius: 10, paddingHorizontal: 15 }}>
                        <View style={{ marginTop: 8, flexDirection: 'row' }}>
                            <View style={{ flex: 1, flexDirection: 'row' }}>
                                <Image source={images.icons.icon_seat_1} style={{ height: 20, width: 20, resizeMode: 'contain' }} />
                                <Text style={{ fontFamily: 'Nunito_700Bold', color: colors.text, fontSize: 15, marginLeft: 5 }}>Doanh thu khách</Text>
                            </View>
                            <View>
                                <Text style={{ fontFamily: 'Nunito_700Bold', color: colors.text, fontSize: 20, marginLeft: 5 }}>{data?.percent_customer?.revenue_customer?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                            </View>
                        </View>
                        <View style={{ flexDirection: 'row', marginBottom: 16, marginTop: 8 }}>
                            <View style={{
                                height: 28, position: 'relative', flex: 1, backgroundColor: colors.process_background, borderRadius: 3,
                                justifyContent: 'center'
                            }}>
                                <View style={{
                                    position: 'absolute', top: 0, left: 0, width: `${data?.percent_customer?.revenue_customer_last > 100 ? 100 : data?.percent_customer?.revenue_customer_last}%`,
                                    height: '100%', backgroundColor: getColorProgress(data?.percent_customer?.revenue_customer_last), borderRadius: 3
                                }} />
                                <View style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', justifyContent: 'center' }}>
                                    <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', paddingHorizontal: 6 }}>{data?.percent_customer?.revenue_customer_last}% tuần trước</Text>
                                </View>
                            </View>
                            <View style={{ width: 16 }} />
                            <View style={{
                                height: 28, position: 'relative', flex: 1, backgroundColor: colors.process_background, borderRadius: 3,
                                justifyContent: 'center'
                            }}>
                                <View style={{
                                    position: 'absolute', top: 0, left: 0, width: `${data?.percent_customer?.revenue_customer_plan > 100 ? 100 : data?.percent_customer?.revenue_customer_plan}%`,
                                    height: '100%', backgroundColor: getColorProgress(data?.percent_customer?.revenue_customer_plan), borderRadius: 3
                                }} />
                                <View style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', justifyContent: 'center' }}>
                                    <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', paddingHorizontal: 6 }}>{data?.percent_customer?.revenue_customer_plan}% kế hoạch</Text>
                                </View>
                            </View>
                        </View>
                    </View>

                    <View style={{ backgroundColor: 'white', marginHorizontal: 12, marginTop: 18, borderRadius: 10, paddingHorizontal: 15 }}>
                        <View style={{ marginTop: 8, flexDirection: 'row' }}>
                            <View style={{ flex: 1, flexDirection: 'row' }}>
                                <Image source={images.icons.icon_value} style={{ height: 20, width: 20, resizeMode: 'contain' }} />
                                <Text style={{ fontFamily: 'Nunito_700Bold', color: colors.text, fontSize: 15, marginLeft: 5 }}>Doanh thu hàng</Text>
                            </View>
                            <View>
                                <Text style={{ fontFamily: 'Nunito_700Bold', color: colors.text, fontSize: 20, marginLeft: 5 }}>{data?.percent_product?.revenue_product?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                            </View>
                        </View>
                        <View style={{ flexDirection: 'row', marginBottom: 16, marginTop: 8 }}>
                            <View style={{
                                height: 28, position: 'relative', flex: 1, backgroundColor: colors.process_background, borderRadius: 3,
                                justifyContent: 'center'
                            }}>
                                <View style={{
                                    position: 'absolute', top: 0, left: 0, width: `${data?.percent_product?.revenue_product_last > 100 ? 100 : data?.percent_product?.revenue_product_last}%`,
                                    height: '100%', backgroundColor: getColorProgress(data?.percent_product?.revenue_product_last), borderRadius: 3
                                }} />
                                <View style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', justifyContent: 'center' }}>
                                    <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', paddingHorizontal: 6 }}>{data?.percent_product?.revenue_product_last}% tuần trước</Text>
                                </View>
                            </View>
                            <View style={{ width: 16 }} />
                            <View style={{
                                height: 28, position: 'relative', flex: 1, backgroundColor: colors.process_background, borderRadius: 3,
                                justifyContent: 'center'
                            }}>
                                <View style={{
                                    position: 'absolute', top: 0, left: 0, width: `${data?.percent_product?.revenue_product_plan > 100 ? 100 : data?.percent_product?.revenue_product_plan}%`,
                                    height: '100%', backgroundColor: getColorProgress(data?.percent_product?.revenue_product_plan), borderRadius: 3
                                }} />
                                <View style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', justifyContent: 'center' }}>
                                    <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', paddingHorizontal: 6 }}>{data?.percent_product?.revenue_product_plan}% kế hoạch</Text>
                                </View>
                            </View>
                        </View>
                    </View>

                    <View style={{ flexDirection: 'row', paddingHorizontal: 12, marginTop: 18 }}>
                        <View style={{ flex: 1, backgroundColor: 'white', borderRadius: 10, paddingHorizontal: 12, paddingTop: 8, paddingBottom: 12, flexDirection: 'column' }}>
                            <View style={{ flexDirection: 'row' }}>
                                <View style={{ flex: 1 }}>
                                    <Text style={{ fontFamily: 'Nunito_700Bold', color: colors.text }}>Doanh thu / lượt</Text>
                                    <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 24, color: colors.text, lineHeight: 28 }}>{Math.round(data?.revenue_medium_turn.revenue_turn).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                                </View>
                            </View>
                            <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 11, color: colors.text_sub }}>{data?.revenue_medium_turn?.number_turn?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} lượt</Text>
                            <View style={{ flexDirection: 'column', justifyContent: 'center', marginTop: 6 }}>
                                <View style={{
                                    height: 25, position: 'relative', backgroundColor: colors.process_background, borderRadius: 3,
                                    justifyContent: 'center'
                                }}>
                                    <View style={{
                                        position: 'absolute', top: 0, left: 0, width: `${data?.revenue_medium_turn?.percent_revenue_turn > 100 ? 100 : data?.revenue_medium_turn?.percent_revenue_turn}%`,
                                        height: '100%', backgroundColor: getColorProgress(data?.revenue_medium_turn?.percent_revenue_turn), borderRadius: 3
                                    }} />
                                    <View style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', justifyContent: 'center' }}>
                                        <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', paddingHorizontal: 6, fontSize: 10 }}>{data?.revenue_medium_turn?.percent_revenue_turn}%</Text>
                                    </View>
                                </View>
                            </View>
                        </View>
                        <View style={{ width: 16 }}></View>

                        <View style={{ flex: 1, backgroundColor: 'white', borderRadius: 10, paddingHorizontal: 12, paddingTop: 8, paddingBottom: 12, flexDirection: 'column' }}>
                            <View style={{ flexDirection: 'row', justifyContent: 'center' }}>
                                <View style={{ flex: 1 }}>
                                    <Text style={{ fontFamily: 'Nunito_700Bold', color: colors.text }}>Doanh thu / xe</Text>
                                    <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 24, color: colors.text, lineHeight: 28 }}>{Math.round(data?.revenue_medium_vehicle?.revenue_vehicle).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                                </View>
                            </View>
                            <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 11, color: colors.text_sub }}>{data?.revenue_medium_vehicle?.number_vehicle?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} xe</Text>
                            <View style={{ flexDirection: 'column', justifyContent: 'center', marginTop: 6 }}>
                                <View style={{
                                    height: 25, position: 'relative', backgroundColor: colors.process_background, borderRadius: 3,
                                    justifyContent: 'center'
                                }}>
                                    <View style={{
                                        position: 'absolute', top: 0, left: 0, width: `${data?.revenue_medium_vehicle?.revenue_vehicle_plan > 100 ? 100 : data?.revenue_medium_vehicle?.revenue_vehicle_plan}%`,
                                        height: '100%', backgroundColor: getColorProgress(data?.revenue_medium_vehicle?.revenue_vehicle_plan), borderRadius: 3
                                    }} />
                                    <View style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', justifyContent: 'center' }}>
                                        <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', paddingHorizontal: 6, fontSize: 10 }}>{data?.revenue_medium_vehicle?.revenue_vehicle_plan}%</Text>
                                    </View>
                                </View>
                            </View>
                        </View>
                    </View>

                    <View style={{
                        backgroundColor: 'white', marginHorizontal: 12, marginTop: 18, borderRadius: 10, paddingHorizontal: 11, flexDirection: 'row',
                        paddingTop: 8, paddingBottom: 12, alignItems: 'center'
                    }}>
                        <View style={{ flexDirection: 'column', flex: 1, justifyContent: 'center' }}>
                            <Text style={{ fontFamily: 'Nunito_700Bold', color: colors.text, fontSize: 15 }}>Giá vé bình quân</Text>
                            <Text style={{ fontFamily: 'Nunito_700Bold', color: colors.text, fontSize: 24, marginTop: 4 }}>{Math.round(data?.fare_medium?.fare_medium).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                        </View>
                        <Text style={{ color: colors.text, fontSize: 11 }}>Tương đương với</Text>
                        <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'flex-end' }}>
                            <View style={{ position: 'relative' }}>
                                <AnimatedProgressWheel
                                    size={70}
                                    width={10}
                                    color={getColorProgress(data?.fare_medium?.percent_fare)}
                                    backgroundColor={colors.process_background}
                                    progress={parseFloat(data?.fare_medium?.percent_fare)}
                                    animateFromValue={0}
                                    duration={3000}
                                />
                                <View style={{ width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center', position: 'absolute', top: 0 }}>
                                    <Text style={{
                                        fontFamily: 'Nunito_700Bold', color: getColorText(data?.fare_medium?.percent_fare),
                                        fontSize: 10, textAlign: 'center', marginTop: 5
                                    }}>{Math.round(data?.fare_medium?.percent_fare * 100) / 100}%{'\n'}kh</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={{ marginBottom: 16 }} />
                </> : (
                    !refreshing ? <View style={{ marginTop: 80, flexDirection: 'column', alignItems: 'center' }}>
                        <Image source={images.server_error} style={{ width: 200, height: 200 }} />
                        <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', marginTop: 24, fontSize: 18 }}>Đã có lỗi xảy ra</Text>
                        <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', fontSize: 18 }}>Vui lòng ấn nút bên dưới để thử lại</Text>
                        <TouchableOpacity onPress={onRefresh}>
                            <Image source={images.refresh} style={{ width: 40, height: 40, marginTop: 16 }} />
                        </TouchableOpacity>
                    </View> : null
                )
            }
        </ScrollView>
    );
})